import { render, staticRenderFns } from "./counselor-detail.vue?vue&type=template&id=73f1fedf&"
import script from "./counselor-detail.vue?vue&type=script&lang=js&"
export * from "./counselor-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports